/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/379-paragraph-justify': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M0 1h16v2H0zm0 3h16v2H0zm0 3h16v2H0zm0 3h16v2H0zm0 3h16v2H0z"/>'
  }
})
